<template>
  <b-form class="view-crud-form">
    <label for="inline-form-custom-select-pref">
      View:
    </label>
    <b-input-group>
      <b-form-input
        id="mdmViewInputName"
        v-model="inputText"
        placeholder="Type and hit enter"
        @keyup.enter="onViewSave"
      />
      <b-input-group-append>
        <b-button
          v-if="selectedView.viewGuid"
          id="mdmViewUpdateButton"
          :disabled="buttonsDisabled"
          variant="primary"
          @click="onViewSave"
        >
          <!--          <b-spinner small v-if="buttonsDisabled"/>-->
          Update
        </b-button>
        <b-button
          id="mdmViewCreateButton"
          :disabled="!inputText || buttonsDisabled"
          variant="success"
          @click="onViewSave(false)"
        >
          <!--          <b-spinner small v-if="buttonsDisabled"/>-->
          {{ selectedView.viewGuid ? 'Save as New' : 'Create' }}
        </b-button>
        <b-button
          id="mdmViewMakeDefaultButton"
          :disabled="buttonsDisabled || !selectedView.viewGuid"
          variant="secondary"
          @click="markAsDefault"
        >
          <!--          <b-spinner small v-if="buttonsDisabled"/>-->
          Make Default
        </b-button>
        <b-button
          id="mdmViewDeleteButton"
          type="button"
          :disabled="buttonsDisabled || !selectedView.viewGuid"
          variant="danger"
          @click="onDeleteClick"
        >
          Delete
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>
<script>

import {createNamespacedHelpers} from 'vuex';
import MenuService from '@/core/components/sidebar/MenuService';

const {mapState, mapActions, mapGetters} = createNamespacedHelpers('dataManagement');
export default {
  name: 'EntityViewsCrud',
  props: {
    views: {
      type: Array,
    },
    entityUuid: {
      required: true,
      type: String,
    },
    loading: {
      type: Boolean,
    },
    filters: {},
    styles: {},
    params: {},
    stickyColumns: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    inputText: null,
    buttonsDisabled: false,
  }),
  watch: {
    'selectedView.viewName': {
      handler() {
        if (this.selectedView.viewGuid) {
          this.inputText = this.selectedView.viewName;
        } else {
          this.inputText = '';
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(['table']),
    selectedView() {
      return this.views.find(v => v.isSelected) || {};
    },
  },
  methods: {
    ...mapActions(['createOrUpdateMDMView', 'makeMDMViewDefault', 'deleteMDMView']),
    async onViewSave(update = true) {
      const inputText = this.inputText.trim();
      if (inputText === 'Default') {
        this.$toasted.error(`The view name "${inputText}" is preserved name`, {
          duration: TOASTER_DURATION,
        });
        return;
      }

      const tmpView = this.views.find(v => {
        if (update) {
          return inputText === v.viewName && v.viewGuid !== this.selectedView.viewGuid;
        }
        return inputText === v.viewName;
      });
      if (tmpView) {
        this.$toasted.error(`View with name ${inputText} already exists`, {
          duration: TOASTER_DURATION,
        });
        return;
      }

      this.buttonsDisabled = true;
      const params = JSON.parse(JSON.stringify(this.params));
      delete params.id;
      delete params.pageNumber;
      const data = {
        viewName: inputText,
        entityGuid: this.entityUuid,
        viewJSON: JSON.stringify({
          frontFilters: this.filters,
          filters: params.filters,
          sortCriteria: params.sortCriteria,
          pageSize: params.pageSize,
          groupBy: params.groupBy,
          subGroupBy: params.subGroupBy,
          toggleColumns: this.table.schema.toggleColumns,
          stickyColumns: this.stickyColumns,
          styles: this.styles,
        }),
        isDefault: update ? this.selectedView.isDefault : false,
      };
      if (update) {
        data.viewGuid = this.selectedView.viewGuid;
      }

      const {success, errors, body} = await this.createOrUpdateMDMView(data);

      if (success) {
        this.$toasted.success(`View ${inputText} was saved`, {
          duration: TOASTER_DURATION,
        });
        // this.$emit('save', body)
      } else {
      }

      this.buttonsDisabled = false;
    },
    async onDeleteClick() {
      const confirmed = await this.$confirm(
        'Deleting view...',
        'Are you sure you want to delete selected view?',
      );
      if (!confirmed) return;

      this.buttonsDisabled = true;
      const viewName = this.selectedView.viewName;
      const {success, body} = await this.deleteMDMView(this.selectedView.viewGuid);

      if (success) {
        this.inputText = '';
        this.$toasted.success(
          `View ${viewName} was deleted`,
          {duration: TOASTER_DURATION},
        );

        this.$emit('chooseView', {view: null});
      }
      this.buttonsDisabled = false;
      // await this.loadData();
    },
    async markAsDefault() {
      this.buttonsDisabled = true;
      const {success, body} = await this.makeMDMViewDefault(this.selectedView);
      if (success) {
        const moduleUuid = this.$route.params.moduleUuid;
        const tableId = this.$route.params.tableId;

        const myModule = MenuService.getItem(`module-${moduleUuid}`);
        if (myModule) {
          MenuService.removeItem(`module-${moduleUuid}`);
          const table = myModule.children.find(t => t.uuid === tableId);
          if (table) {
            // Get the current URL
            const currentURL = table.path;
            const url = new URL('https://example.com' + currentURL);
            url.searchParams.set('view', body.viewDto.viewGuid);
            table.path = url.pathname + url.search;

            MenuService.addItem(myModule);
          }
        }
        this.$toasted.success(`View ${this.selectedView.viewName} was marked as default`, {
          duration: TOASTER_DURATION,
        });
      }
      this.buttonsDisabled = false;
    },
  },
};
</script>

<style scoped lang="scss">
.views-dropdown {
  width: 360px;
  padding: 0;
  margin: 0;

  .b-dropdown-form {
    padding: 0;
  }

  .edit-icon, .delete-icon {
    cursor: pointer;
  }
}

.view-crud-form {
  display: flex;
  align-items: center;
  gap: 10px;

  label {
    margin-bottom: 0;
  }
}
</style>